<template>
    <div
        class="catalog-layout catalog row"
        :class="{ 'is-loading': showLoader }"
    >
        <aside v-if="$slots.aside" class="col-md-3 hidden-mobile aside--left">
            <slot name="aside" />
            <LazyHydrate never>
                <div
                    v-if="isSearchPage"
                    id="div-gpt-ad-1676540201424-0"
                    class="dfpAd"
                ></div>
                <div
                    v-else-if="!isMobile"
                    id="div-gpt-ad-RECTANGLE-0"
                    class="dfpAd"
                ></div>
            </LazyHydrate>
        </aside>
        <div class="content" :class="$slots.aside ? 'col-md-9' : 'col-md-12'">
            <slot />
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import resizeObserver from '@vue/utils/resizeObserver.js'
import LazyHydrate from 'vue-lazy-hydration'
export default {
    components: {
        LazyHydrate
    },
    mixins: [resizeObserver],
    props: {
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showLoader: false,
            loaderTimeout: null
        }
    },
    computed: {
        ...mapGetters(['isSearchPage'])
    },
    watch: {
        isLoading(value) {
            clearTimeout(this.loaderTimeout)
            this.showLoader = false
            if (value) {
                this.loaderTimeout = setTimeout(() => {
                    this.showLoader = true
                }, 350)
            }
        }
    }
}
</script>
<style lang="scss">
.catalog-layout {
    position: relative;
    margin-bottom: 25px;

    .aside--left {
        @media #{$media-md} {
            margin-left: -15px;
            width: 256px;
            padding-right: 0;
        }

        @media #{$media-lg} {
            width: 290px;
        }
        padding-left: 0rem;
    }

    &::before {
        content: '';
        opacity: 0;
        pointer-events: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255, 0.6);
        z-index: 10;

        @include n-transition(opacity, 0.3s);
    }

    &.is-loading {
        &::before {
            opacity: 1;
            display: block;
            pointer-events: initial;
        }
    }

    @include clearfix();
}
</style>
